export default "__VITE_ASSET__CDT_iBqx__"